import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Step, StepLabel, Stepper } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import SurveyBasicDetailsForm from "./SurveyBasicDetailsForm";
import AddQuestionsForm from "./AddQuestionsForm";
import SubmitSurveyForm from "./SubmitSurveyForm";
import useAddModal from "./useAddModal";

export default function AddSurveyModal({ openModal, handleCloseModal }) {

    const { formik, isLoading, handleSubmit } = useAddModal({ handleCloseModal });

    const [activeStep, setActiveStep] = useState(0);
    const steps = ['Survey Basic Details', 'Add Questions', 'Submit Survey'];

    const handleNext = () => {
        if(activeStep==2){
            return;
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSubmitForm = () => {
        handleSubmit();
    }

    return (
        <Dialog fullWidth maxWidth={"md"} open={openModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle sx={{ textAlign: 'center' }}>Add Survey</DialogTitle>
            <IconButton aria-label="close" onClick={handleCloseModal} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}>
                <CloseIcon />
            </IconButton>

            <Stepper sx={{ mb: 2 }} activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            <DialogContent dividers>
                {activeStep === 0 && <SurveyBasicDetailsForm formik={formik}/>}
                {activeStep === 1 && <AddQuestionsForm formik={formik}/>}
                {activeStep === 2 && <SubmitSurveyForm formik={formik} isLoading={isLoading} handleSubmit={handleSubmitForm}/>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseModal}>Cancel</Button>
                <Button onClick={handleBack} disabled={activeStep === 0}>Back</Button>
                <Button onClick={handleNext} disabled={activeStep === 2} variant="contained" color="primary">
                    Next
                </Button>
            </DialogActions>
        </Dialog>
    );
}